const language = {
	spanish: {
		titleBanner: "Manejo de ",
		spanTitleYellow: "Equipo Pesado",
		equipo_pesado_red_title: "EQUIPO PESADO",
		equipo_pesado_bold_title:
			"Foresight GPS le permite reducir los costos de mantenimiento e incrementar la seguridad de tu maquinaria pesada a través de su alta precisión y versatilidad",
		equipo_pesado_bold_text:
			"G-Evolution es una plataforma de rastreo la cual garantiza a las empresas un conocimiento constante sobre la ubicación de sus equipos pesados en cualquier momento y las condiciones en las que está operando.",
		equipo_pesado_text:
			"El monitoreo por GPS para los equipos de construcción o maquinaria pesada en general, le permite saber la ubicación y desempeño de sus activos móviles. G-Evolution mejora enormemente la productividad de las operaciones de equipos pesados de construcción garantizando la reducción de costos de su empresa o negocio.",
		beneficios_red_title: "BENEFICIOS",
		beneficios_bold_title:
			"Proteja sus activos móviles y comerciales con los múltiples beneficios que Foresight GPS le ofrece como:",
		beneficios_list: [
			{
				text: "Incrementa la eficiencia de su equipamiento pesado y maquinaria.",
				column: "1",
			},
			{ text: "Aumenta el rendimiento del conductor / operador.", column: "1" },
			{
				text: "Reduce el costo de seguros y el uso no autorizado de vehículos.",
				column: "1",
			},
			{ text: "Reduce el costo de combustible y mantenimiento.", column: "1" },
			{
				text: "Maneje toda operación desde cualquier lugar y desde cualquier dispositivo.",
				column: "1",
			},
			{
				text: "Localización precisa de equipos pesados, tanto móviles como estáticos.",
				column: "1",
			},
			{
				text: "Equipe al personal técnico de herramientas de toma de decisiones en campo.",
				column: "2",
			},
			{
				text: "Haga un mantenimiento apropiado de toda la inversión en equipos pesados: maquinaria, herramientas, vehículos.",
				column: "2",
			},
			{
				text: "Gestión de combustible a través de sensores de alta precisión.",
				column: "2",
			},
			{
				text: "Previene mantenimientos serios que puedan poner en riesgo la operación de la maquinaria.",
				column: "2",
			},
			{ text: "Soporte 24/7.", column: "2" },
		],
		caracteristicas_red_title: "CARACTERÍSTICAS",
		caracteristicas_bold_text:
			"Nuestro software de gestión es fácil de usar y mejora el rendimiento de los equipos teniendo en cuenta su mantenimiento y uso.",
		caracteristicas_text:
			"Estas funcionalidades ayudan tanto a fabricantes de equipos como a técnicos/operadores a optimizar los recursos de servicio en el campo y en la oficina. Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			"Generación de variedad de alertas según la necesidad de la operación.",
			"Integración de gran catálogo de dispositivos GPS.",
			"Gestión de activos acuáticos desde aplicación web o móvil.",
			"Configuración de alertas de mantenimiento preventivo por distancia u horas de uso.",
			"Configuración de alertas de proximidad entre embarcaciones",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Fue diseñado para visualizar los indicadores clave de rendimiento de forma rápida y eficiente, facilitando la toma de decisiones ante grandes volúmenes de datos.",
		dashboard_bold_text:
			"Con distintos conjuntos de tableros puedes ver la velocidad media, máxima y promedio de la flota, el kilometraje por unidad, el consumo de combustible promedio individual o por flota, las horas del motor encendido y el tiempo en los viajes, y más.",
		dashboard_text:
			"Además se pueden incluir nuevos sets de datos y personalizar los Dashboard a las necesidad específicas de cada operación.",
		dashboard_list: [
			"Procesamiento de data.",
			"Presentación gráfica de resultados.",
			"Comparativo de resultados entre diferentes equipos.",
			"Identificador de variables fuera de rango.",
			"Interfaz gráfica amigable y fácil de leer.",
			"Control de múltiples variables de manera simultánea.",
			"Información discriminada en operador/vehículo.",
		],
		software_bold_text:
			"El software de mantenimiento y seguimiento de equipos pesados protege los activos que suelen ser una alta inversión para muchas organizaciones.",
		software_text: [
			"Por lo tanto, las organizaciones quieren preservar esa inversión y asegurarse de que esos activos brinden el mejor rendimiento por el dinero gastado.",
			"Cuando el equipo de su organización no se ha mantenido adecuadamente, experimentará más averías. Eso se traduce en dólares perdidos y también ejerce una intensa presión sobre el equipo de mantenimiento para que la producción vuelva a funcionar.",
		],
		form_title: "Deseamos ayudarte, contáctanos ahora:",
		form_button_text: "ENVÍA TU RESUMEN",
		formik_fields: [
			{
				title: "Nombre",
				requestKey: "nombre_apellido",
			},
			{
				title: "Email",
				requestKey: "email",
			},
			{
				title: "País",
				requestKey: "pais",
			},
			{
				title: "Apellido",
				requestKey: "apellido",
			},
			{
				title: "Móvil",
				requestKey: "movil",
			},
			{
				title: "Empresa",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "¿Cómo se enteró de nosotros? *Opcional. ",
				requestKey: "como_se_entero",
			},
		],
	},
	english: {
		titleBanner: "Handling of ",
		spanTitleYellow: "Heavy Equipment",
		equipo_pesado_red_title: "HEAVY EQUIQMENT",
		equipo_pesado_bold_title:
			"ForesightGPS allows you to reduce maintenance costs and increase safety of your heavy machinery though its high precision and versatile platform.",
		equipo_pesado_bold_text:
			"G-Evolution is our tracking platform which guarantees companies constant monitoring of the location of their heavy equipment at any time and in which conditions they are operating.",
		equipo_pesado_text:
			"GPS monitoring for construction equipment or heavy machinery in general, allows you to know the location and its performance. G-Evolution greatly improves the productivity of heavy machinery equipment operations, ensuring the reduction of costs for your business.",
		beneficios_red_title: "BENEFITS",
		beneficios_bold_title:
			"Protect your mobile business assets with the many benefits we offer you, such as:",
		beneficios_list: [
			{
				text: "Increase the efficiency of your heavy equipment and machinery.",
				column: "1",
			},
			{ text: "Increase operator performance.", column: "1" },
			{
				text: "Reduces unauthorized use of vehicles and cost of insurance.",
				column: "1",
			},
			{ text: "Reduces costs of fuel and maintenance.", column: "1" },
			{
				text: "Manage all operations from anywhere on any device.",
				column: "1",
			},
			{
				text: "Precise location of mobile and static equipment.",
				column: "1",
			},
			{
				text: "Equip technical staff with decision making tools in the field.",
				column: "2",
			},
			{
				text: "Fuel management through high precision sensors.",
				column: "2",
			},
			{
				text: "Gestión de combustible a través de sensores de alta precisión.",
				column: "2",
			},
			{
				text: "Prevents serious maintenance that could put the machinery at risk.",
				column: "2",
			},
			{ text: "24/7 support.", column: "2" },
		],
		caracteristicas_red_title: "FEATURES",
		caracteristicas_bold_text:
			"Our management software is easy to use and improves equipment performance considering its maintenance and use.",
		caracteristicas_text:
			"These functionalities help both equipment manufacturers and operators to optimize resources in the field and office. We have the best technological innovations for the optimal tracking of your assets:",
		caracteristicas_list: [
			"Generation of a variety of alerts according to the needs of the operation.",
			"Integration of a large catalog of GPS devices.",
			"Management of aquatic assets from a web or mobile application.",
			"Configuration of preventive maintenance alerts by distance or hours of use.",
			"Setting up proximity alerts between vessels",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Designed to display key performance indicators quickly and efficiently, facilitating      decision making when faced with large volumes of data.",
		dashboard_bold_text:
			"With different sets of dashboards you can see the average speed, maximum, milage per unit, average of fuel consumption of the fleet or individual, engine running hours, and more.",
		dashboard_text:
			"Also can be customized to the specific needs of operation, including new data sets. ",
		dashboard_list: [
			"Data processing.",
			"Graphic presentation of results.",
			"Comparison of results between different vehicles.",
			"Out of range variable identifier.",
			"Friendly and easy-to-read graphical interface.",
			"Simultaneous control of multiple variables.",
			"Information on operator and vehicle.",
		],
		software_bold_text:
			"Heavy equipment maintenance and monitoring software protects assets that are often a high investment for many businesses.",
		software_text: [
			"Therefore, organizations want to preserve that investment is extremely important to ensure that those assets provide the best revenue for the money spent.",
			"When the equipment has not been properly maintained it will experience further breakdowns, that translates in lost money and great pressure on the maintenance team to get the equipment working again.",
		],
		form_title: "We want to help you, contact us now:",
		form_button_text: "SEND YOUR SUMMARY",
		formik_fields: [
			{
				title: "First Name",
				requestKey: "nombre_apellido",
			},
			{
				title: "Email",
				requestKey: "email",
			},
			{
				title: "Country",
				requestKey: "pais",
			},
			{
				title: "Last Name",
				requestKey: "apellido",
			},
			{
				title: "Mobile",
				requestKey: "movil",
			},
			{
				title: "Company",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "How did you hear about us? *Optional. ",
				requestKey: "como_se_entero",
			},
		],
	},
};

export default language;
